<template>
  <div class="wrapper">
    <template v-if="isMobile">
      <div class="mobile"></div>
      <!-- 移动端 -->
      <div class="headerBar">
        <div class="head-content">
          <div class="mobile-menu" ref="mobileMenu">
            <div class="mark" ref="mark" @click="close()"></div>
            <div class="menu">
              <img class="mobile-icon" :src="oosUrl+'/img/menu.png'" @click="evt_show" />
              <router-link to="/index">
                <img class="mobile-logo" src="https://blue-dash.oss-cn-shanghai.aliyuncs.com/blue_dash_pc_img_v2/header/headLogo.png" />
              </router-link>
            </div>
          </div>
          <div class="mobile-nav" ref="menuList">
            <img class="closeIcon" ref="menuClose" :src="oosUrl+'/img/close.png'" @click="close()" />
            <ul class="nav">
              <li v-for="item in configNav" :key="item.id" :class="{ active: $route.meta.index == item.id }"
                @click="handelTab(item)">
                <p class="chinese">{{ item.chineseName }}</p>
                <p class="eng">{{ item.name }}</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </template>

    <template v-else>
      <div class="pc-headerBar" id="pc-headerBar">
        <!-- webPc导航 -->
        <div ref="logo" class="logo">
          <router-link to="/index">
            <img src="https://blue-dash.oss-cn-shanghai.aliyuncs.com/blue_dash_pc_img_v2/header/headLogo.png" />
          </router-link>
        </div>
        <div class="nav" ref="menuList">
          <div v-for="item in configNav" :key="item.id" :class="{ item, active: $route.meta.index == item.id }"
            @click="handelTab(item)">
            <p class="nav-name">{{ item.chineseName }}</p>
            <p class="nav-text">{{ item.name }}</p>
          </div>
        </div>
      </div>
      <div :class="show?' isFixed pc-headerBar':'pc-headerBar' " id="pc-headerBar" v-if="show">
        <!-- webPc导航 -->
        <div ref="logo" class="logo">
          <router-link to="/index">
            <img src="https://blue-dash.oss-cn-shanghai.aliyuncs.com/blue_dash_pc_img_v2/header/headLogo.png" />
          </router-link>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  import utils from "@/utils/utils";
  export default {
    name: "headerBar",
    data() {
      return {
        isMobile: false,
        oosUrl: "https://blue-dash.oss-cn-shanghai.aliyuncs.com",
        configNav: [
          { id: 0, chineseName: "首页", name: "HOME PAGE", path: "/index" },
          {
            id: 1,
            chineseName: "关于布鲁大师",
            name: "ABOUT BLUE DASH",
            path: "/about",
          },
          {
            id: 2,
            chineseName: "产品系列",
            name: "DASH PRODUCTS",
            path: "/products",
          },
          {
            id: 3,
            chineseName: "品牌文化",
            name: "DASH CULTURE",
            path: "/culture",
          },
          { id: 4, chineseName: "布鲁研酒所", name: "DASH LAB", path: "/lab" },
          {
            id: 5,
            chineseName: "联系我们",
            name: "CONTACT US",
            path: "/contact",
          },
        ],
        show: false,
      };
    },

    mounted() {
      window.addEventListener("scroll", this.scrollHandle); //绑定页面滚动事件
      // this.isMobile = utils.isMobile();
      // window.onresize = () => {
      //   return (() => {
      //     window.screenWidth = document.body.clientWidth;
      //     console.log(this.screenWidth);

      //     that.screenWidth = window.screenWidth;
      //     this.$refs.menuList.style.display =
      //       this.screenWidth > 540 ? "block" : "none";
      //     this.$refs.logo.style.display =
      //       this.screenWidth > 540 ? "block" : "none";
      //     this.$refs.mobileMenu.style.display =
      //       this.screenWidth > 540 ? "none" : "block";
      //   })();
      // };
    },
    methods: {
      scrollHandle(e) {
        if (e.srcElement.scrollingElement.scrollTop > 130) {
          this.show = true;
        } else {
          this.show = false;
        }
      },
      handelTab(e) {
        this.$router.push({ path: e.path });
        // this.close();
      },
      evt_show() {
        this.$refs.menuList.style.display = "block";
        this.$refs.menuClose.style.display = "block";
        this.$refs.mark.style.display = "block";
      },
      close() {
        if (window.screen.width < 540) {
          this.$refs.menuList.style.display = "none";
          this.$refs.menuClose.style.display = "none";
          this.$refs.mark.style.display = "none";
        } else {
          this.$refs.menuList.style.display = "block";
        }
      },
    },
  };
</script>

<style scoped lang="less">
  .isFixed {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    z-index: 999;
    animation: change 1s ease-out;
    display: flex;
    align-items: center;
    justify-content: center;

    @keyframes change {
      0% {
        // height: 0;
        opacity: 0;
      }

      100% {
        // height: 80px;
        opacity: 1;
      }
    }

    img {
      width: 260px;
    }
  }

  .mobile {
    height: 160px;
  }

  .pc-headerBar {
    width: 100%;
    background: #000;
    display: flex;
    flex-direction: column;
    align-items: center;
    display: flex;
    box-sizing: border-box;
    padding: 15px 0 15px 0;
    a {
      height: auto;
    }

    .logo {
      display: flex;
      justify-content: center;
      width: 100%;
     
      align-items: center;
      background-color: #000;
     

      img {
        width: 260px;
      }
    }

    .nav {
      width: 100%;
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      margin-top: 3px;

      .item {
        cursor: pointer;
      
        color: #fff;
        font-size: 12px;
        padding: 10px;
        box-sizing: border-box;

        &.active {
          position: relative;

          &::after {
            content: "";
            width: 100%;
            height: 4px;
            background: #ffffff;
            position: absolute;
            left: 0;
            bottom: 1px;
          }
        }

        .nav-name {
          font-size: 20px;
          text-align: center;
          letter-spacing: 4px;
          margin-bottom: 4px;
        }

        .nav-text {
          font-size: 12px;
          text-align: center;
          color: #ffffff;
          white-space: nowrap;
          margin-top: 2px;
        }
      }
    }
  }

  .headerBar {
    width: 100%;
    height: 160px;
    background: #000;
    box-sizing: border-box;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9;

    .head-content {
      padding: 0 40px;

      .mobile-menu {
        width: 100%;
        display: block;

        .mark {
          display: none;
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 998;
          background: rgba(0, 0, 0, 0.3);
        }

        .menu {
          z-index: 999;
          width: 100%;
          height: 160px;
          display: flex;
          justify-content: space-between;
          align-items: center;

          img {
            width: 55px;
            height: 55px;
          }

          .mobile-logo {
            width: 260px;
            height: 33px;

            img {
              width: 82px;
              height: 24px;
            }
          }
        }
      }

      .mobile-nav {
        display: none;
        position: fixed;
        top: 0;
        left: 0;
        width: 50%;
        height: 100%;
        background: #000;
        z-index: 998;

        .closeIcon {
          position: absolute;
          top: 50px;
          right: 50px;
          width: 70px;
          height: 70px;
        }

        .nav {
          width: 100%;
          padding: 90px 0 0 40px;
          box-sizing: border-box;

          .active {
            position: relative;

            p {
              color: #4a72f4;
            }

            &::after {
              content: "";
              width: 150px;
              height: 2px;
              background: #4a72f4;
              position: absolute;
              left: 0;
              bottom: 0;
            }
          }

          li {
            color: #fff;
            padding: 40px 0 20px;

            .chinese {
              font-size: 40px;
              line-height: 75px;
            }

            .eng {
              font-size: 35px;
            }
          }
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/HeaderBar.vue